import { Column, Entity, PrimaryGeneratedColumn, ManyToOne } from "typeorm"
import { Rule } from "./Rule.entity";

@Entity()
export class RuleHistory {
  
  @PrimaryGeneratedColumn({ name:"id" })
	id?: number;

  @ManyToOne(() => Rule, rule => rule.history, { onDelete:'CASCADE' })
  rule!: Rule

  @Column()
	event!: string

  @Column()
	details!: string

  @Column('datetime')
	timestamp!: Date;
}